export const getPaymentStatusState = (state) => state.exchange.paymentStatus;
